(function () {

  'use strict';

  angular
    .module('app')
    .filter('filterFloats', [filterFloats]);

    function filterFloats () {
      return function (input) {
        var ret = (input)?input.toString().replace('.',','):null;
        if (ret) {
          var decArr = ret.split(',');
          // if (decArr.length > 1) {
          //   var dec = decArr[1].length;
          //   if (dec === 1) {
          //     ret+='0';
          //   }
          // }
          return ret;
        }
      };
    }

}());